import { defineAction } from "store/utils/action";
import slice from "./slice";
import type { Domain } from "@superblocksteam/shared";

export const setOrganizationState = defineAction<{
  name?: string;
  domains?: Domain[];
}>(slice.name, "setOrganizationState");
